const getters = {
  isaicalling: state => state.call.isaicalling,
  isseatcalling: state => state.call.isseatcalling,
  visitedViews: state => state.tagsView.visitedViews,
  menus: state => state.tagsView.menu,
  caseinfoPageId: state => state.caseInfoPage.caseinfoPageId,
  isRegistered: state => state.webrtc.isRegistered,
  iscalling: state => state.webrtc.iscalling,
  isincall: state => state.webrtc.isincall,
}

export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js